import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClientModule, HttpClient, HttpParams } from '@angular/common/http';
import { of, Observable, ObservableInput } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {

  countries_count: any;
  promoted_location: any;
  countries: any;

  constructor(private http: HttpClient) { }

  getCountries (iataCodes?: Array<String>, lang? ): Observable <any> {
    const countriesURL = environment.apiUrl.baseUrl + environment.apiUrl.services.countries;
    let params;
    params = new HttpParams();
    if (iataCodes) {
      iataCodes.forEach(code => {
        params = params.append('airport_iata_code[]', code);
      });
    }
    if (lang) {
      params = params.append('language_code', lang);
    }
    return this.http
    .get(countriesURL, {params: params})
    .pipe( map(
    (response: any) => {
        this.countries = response.countries;
        this.countries_count = response.countries_count;
        this.promoted_location = response.promoted_location;
        return response;
      },
      error => {
        console.warn(error);
        return error;
      }
    ));
  }
}
